module.exports = __webpack_public_path__ + "static/lunchtype23-regular-italic-webfont-4f58ecedc26d789c21c8109014e222f5.woff2";